function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8333 3.66683C10.8333 1.82516 9.34158 0.333496 7.49992 0.333496C5.65825 0.333496 4.16658 1.82516 4.16658 3.66683C4.16658 5.5085 5.65825 7.00016 7.49992 7.00016C9.34158 7.00016 10.8333 5.5085 10.8333 3.66683ZM12.4999 5.3335V7.00016H14.9999V9.50016H16.6666V7.00016H19.1666V5.3335H16.6666V2.8335H14.9999V5.3335H12.4999ZM0.833252 12.0002V13.6668H14.1666V12.0002C14.1666 9.78349 9.72492 8.66683 7.49992 8.66683C5.27492 8.66683 0.833252 9.78349 0.833252 12.0002Z",
  fill: "white"
});

function SvgAddPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatient);
export default __webpack_public_path__ + "static/media/add-patient.014de9d1.svg";
export { ForwardRef as ReactComponent };